import { PROXY_PATH } from '@app/constants/navigation';

import { isProxyFramePath } from './bridgeMessages';

import type { ProxyEnvironment } from '../types';

export const getProxyEnvironment = (mode: string): ProxyEnvironment | null => {
  if (mode === 'development') return 'dev';
  if (mode === 'staging') return 'stage';
  if (mode === 'production') return 'prod';

  return null;
};

export const getProxyServiceOrigin = (
  value: string,
  mode: string
): string | null => {
  try {
    const url = new URL(value);
    const isLocalhost = url.hostname === 'localhost';
    const isDevelopmentLocalhost =
      isLocalhost && mode === 'development' && url.protocol === 'http:';
    const isHttpsRemote = !isLocalhost && url.protocol === 'https:';

    if (!isDevelopmentLocalhost && !isHttpsRemote) return null;
    if (url.username || url.password || url.search || url.hash) return null;
    if (url.pathname !== '/' || value.endsWith('/')) return null;

    return url.origin === value ? value : null;
  } catch {
    return null;
  }
};

export const getProxyFramePath = (pathname: string, search: string): string => {
  const routePath = pathname.startsWith(`${PROXY_PATH}/`)
    ? pathname.slice(PROXY_PATH.length)
    : '/';
  const normalizedSearch = new URLSearchParams(search).toString();
  const framePath = normalizedSearch
    ? `${routePath}?${normalizedSearch}`
    : routePath;

  return isProxyFramePath(framePath) ? framePath : '/';
};

export const getProxyCrmPath = (framePath: string): string => {
  if (framePath === '/') return PROXY_PATH;
  if (framePath.startsWith('/?')) return `${PROXY_PATH}${framePath.slice(1)}`;

  return `${PROXY_PATH}${framePath}`;
};
